
import { defineComponent, nextTick, PropType, ref, toRef, watchEffect } from 'vue';

import { ServerValidationError } from '@/libs/registrationState';
import { FormLabel, translateFormLabel } from '@/libs/form';
import {
  LABEL_REGISTRATION_EMAIL_SENT,
  LABEL_REGISTRATION_ENTER_CODE,
  LABEL_REGISTRATION_INVALID_CODE,
  LABEL_SEND,
  LABEL_REGISTRATION_EMAIL_VERIFY_TITLE,
  LABEL_REGISTRATION_EMAIL_NOT_RECEIVED,
  LABEL_REGISTRATION_EDIT_EMAIL,
  LABEL_CLOSE,
  LABEL_REGISTRATION_ENTERED_INVALID_EMAIL,
  LABE_REGISTRATION_RESEND_CODE,
  LABEL_REGISTRATION_EMAIL_SPAM_FOLDER,
  LABE_REGISTRATION_EMAIL_WHITE_LIST,
} from '@/libs/i18nLabels';
import PanelHeader from './panel-header.vue';
import focus from '../libs/focus';

export default defineComponent({
  components: {
    PanelHeader,
  },

  props: {
    email: { type: String, required: true },
    codeLength: { type: Number, required: true },
    customerEmail: { type: String, required: false },
    validationErrors: {
      type: Object as PropType<ServerValidationError[]>,
    },

    processing: { type: Boolean },
  },

  emits: ['codeSubmitted', 'onBack', 'resendCode'],

  setup(props) {
    const isCodeInvalid = ref(false);
    const codeMessage = ref<FormLabel | null>(null);
    const isModalActived = ref(false);

    const btnHelpPanel = ref<HTMLElement | null>(null);

    // server validation errors

    function displayServerValidationError(err: ServerValidationError) {
      let { field = '' } = err;

      // Lower case field name
      field = field.toLowerCase();

      switch (field) {
        case 'code':
          isCodeInvalid.value = true;
          codeMessage.value = { label: LABEL_REGISTRATION_INVALID_CODE };
          break;

        default:
          break;
      }
    }

    const validationErrors = toRef(props, 'validationErrors');
    watchEffect(() => {
      if (validationErrors.value) {
        validationErrors.value.forEach((validationError) => {
          displayServerValidationError(validationError);
        });
      }
    });

    function displayModal() {
      isModalActived.value = true;

      nextTick(() => {
        focus(btnHelpPanel.value);
      });
    }

    return {
      isCodeInvalid,
      codeMessage,
      isModalActived,
      btnHelpPanel,
      displayModal,
      LABEL_SEND,
      LABEL_REGISTRATION_EMAIL_VERIFY_TITLE,
      LABEL_REGISTRATION_EMAIL_NOT_RECEIVED,
      LABEL_REGISTRATION_EDIT_EMAIL,
      LABEL_REGISTRATION_ENTERED_INVALID_EMAIL,
      LABEL_REGISTRATION_EMAIL_SPAM_FOLDER,
      LABE_REGISTRATION_EMAIL_WHITE_LIST,
      LABE_REGISTRATION_RESEND_CODE,
      LABEL_CLOSE,
    };
  },

  data() {
    return {
      code: '',
    };
  },

  mounted() {
    focus(this.$refs.codeField);
  },

  methods: {
    onCodeKeyPress() {
      this.isCodeInvalid = false;
      this.codeMessage = null;
    },

    async verify() {
      if (this.processing) {
        return;
      }

      if (this.code.length !== this.codeLength) {
        this.isCodeInvalid = true;
        this.codeMessage = { label: LABEL_REGISTRATION_INVALID_CODE };
        return;
      }

      this.codeMessage = null;
      this.isCodeInvalid = false;

      this.$emit('codeSubmitted', this.code);
    },

    translate(formLabel: FormLabel) {
      return translateFormLabel(formLabel, this.$t);
    },
  },

  computed: {
    customerDomain(): string {
      if (!this.customerEmail) {
        return '';
      }
      return this.customerEmail.split('@')[1];
    },

    subTitleLabel(): string {
      return this.$t(LABEL_REGISTRATION_EMAIL_SENT, [`<b>${this.email}</b>`]).toString();
    },

    codePlaceHolder() {
      return this.$t(LABEL_REGISTRATION_ENTER_CODE).toString();
    },

    codeMessageLabel() {
      if (!this.codeMessage) {
        return '&nbsp';
      }
      return translateFormLabel(this.codeMessage, this.$t);
    },
  },
});
